import { render } from "./AddReview.vue?vue&type=template&id=4f253764"
import script from "./AddReview.vue?vue&type=script&lang=js"
export * from "./AddReview.vue?vue&type=script&lang=js"

import "./AddReview.vue?vue&type=style&index=0&id=4f253764&lang=css"

import exportComponent from "/vercel/path0/Web_Apps/Dorm_Review/WebUI/UI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__